import React from 'react';

function InProgressIcon() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20" enableBackground="new 0 0 20 20">
      <title>In Progress</title>
      <path fill="#404040" d="M10,8C9.5,8,9,8.4,9,9v3h5c0.6,0,1-0.5,1-1.1v0 c0-0.6-0.4-0.9-1-0.9h-3V9C11,8.4,10.6,8,10,8 M17,11c-0.5,0-0.9,0.4-1,0.9c-0.5,3.3-3.7,5.8-7.3,5c-2.3-0.5-4.1-2.3-4.6-4.6 C3.3,8.4,6.3,5,10,5v2l5-3l-5-3v2c-5,0-8.9,4.5-7.9,9.6c0.6,3.1,3.1,5.6,6.3,6.2c4.7,0.9,8.9-2.3,9.6-6.7C18.1,11.5,17.6,11,17,11" />
    </svg>
  );
}

export default InProgressIcon;



// WEBPACK FOOTER //
// ./src/components/icons/InProgressIcon.js